import { useState } from 'react';
import CoproSettings from './CoproSettings';

type CoproTab = 'lefeuvre' | 'newco' | 'syndic';

export default function CoproTabsSettings() {
  const [activeTab, setActiveTab] = useState<CoproTab>('lefeuvre');

  const tabs: { id: CoproTab; label: string; color: string }[] = [
    { id: 'lefeuvre', label: 'Copro Lefeuvre', color: 'blue' },
    { id: 'newco', label: 'Copro NewCo', color: 'green' },
    { id: 'syndic', label: 'Copro Kermarrec Syndic', color: 'purple' }
  ];

  const getTabClasses = (tab: CoproTab) => {
    const isActive = activeTab === tab;
    const baseClasses = 'px-4 py-2 text-sm font-medium rounded-lg transition-colors';
    
    if (isActive) {
      switch (tab) {
        case 'lefeuvre':
          return `${baseClasses} bg-blue-100 text-blue-700`;
        case 'newco':
          return `${baseClasses} bg-green-100 text-green-700`;
        case 'syndic':
          return `${baseClasses} bg-purple-100 text-purple-700`;
      }
    }
    
    return `${baseClasses} text-gray-600 hover:bg-gray-100`;
  };

  return (
    <div className="space-y-6">
      {/* Sous-onglets */}
      <div className="flex space-x-2 border-b border-gray-200 pb-4">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={getTabClasses(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Contenu */}
      <CoproSettings type={activeTab} />
    </div>
  );
}
